import React, { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../../../config";
import UpdateHome from "./UpdateHome"; // Update component for editing entries
import { Link } from "react-router-dom";
import imageCompression from "browser-image-compression";

const apiUrl = config.apiUrl;
const imageUrl = config.imageUrl;

const ViewHome = () => {
  const [homes, setHomes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingHome, setEditingHome] = useState(null);
  const [photo, setPhoto] = useState("");
  const [formData, setFormData] = useState({
    topBar: "",
    headline: "",
    slug: "",
    subHeadline: "",
    paragraph: "",
    image:null,
    timeText: "",
    startsText: "",
    startsIn: "",
    seatGrabText: "",
    buttonHeadlineText: "",
    buttonSubheadlineText: "",
    secretsHeadline: "",
    secretsText: "",
    footerText: "",
    pixelId: "",
  });


    // ইমেজ কম্প্রেশন অপশন
    const imageCompressionOptions = {
      maxSizeMB: 0.5, // সর্বোচ্চ সাইজ 0.5MB
      maxWidthOrHeight: 1024, // সর্বোচ্চ রেজোলিউশন
      useWebWorker: true,
      fileType: "image/webp" // WebP ফরম্যাটে কনভার্ট করবে
    };
  
  // Fetch homes from API
  useEffect(() => {
    const fetchHomes = async () => {
      try {
        const response = await axios.get(`${apiUrl}/homepages`);
        setHomes(response.data.homepages);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching homes:", err);
        setError("Failed to load homes.");
        setLoading(false);
      }
    };

    fetchHomes();
  }, []);

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this home?")) {
      try {
        await axios.delete(`${apiUrl}/homepagedelete/${id}`);
        setHomes((prev) => prev.filter((home) => home.id !== id));
      } catch (err) {
        console.error("Error deleting home:", err);
        setError("Failed to delete home.");
      }
    }
  };



  // Handle Edit Button Click
  const handleEditClick = (home) => {
    setEditingHome(home.id);
    setFormData({
      topBar: home.topBar,
      headline: home.headline,
      slug: home.slug,
      subHeadline: home.subHeadline,
      paragraph: home.paragraph,
      image: home.image,
      timeText: home.timeText,
      startsText: home.startsText,
      startsIn: home.startsIn,
      seatGrabText: home.seatGrabText,
      buttonHeadlineText: home.buttonHeadlineText,
      buttonSubheadlineText: home.buttonSubheadlineText,
      secretsHeadline: home.secretsHeadline,
      secretsText: home.secretsText,
      footerText: home.footerText,
      pixelId: home.pixelId,
    });
  };


  // কম্প্রেসড ইমেজ হ্যান্ডলার
    const handleImageChange = async (e) => {
      const file = e.target.files[0];
      if (!file) {
        // যদি ব্যবহারকারী কোনো ফাইল সিলেক্ট না করে
        setFormData(prev => ({ ...prev, image: null }));
        return;
      }

      try {
        const compressedBlob = await imageCompression(file, imageCompressionOptions);
        const fileName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
        const compressedFile = new File([compressedBlob], fileName, {
          type: "image/webp",
          lastModified: Date.now()
        });

        setFormData(prev => ({ ...prev, image: compressedFile }));
        setPhoto(URL.createObjectURL(compressedFile)); // প্রিভিউ দেখানোর জন্য
      } catch (error) {
        console.error("Image compression error:", error);
        setError("Failed to compress image");
      }
    };

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      secretsText: value || "", // খালি ভ্যালুর জন্য "" সেট করুন
    }));
  };
  
  console.log(formData)

  // Handle Form Submit
  // Update the handleSubmit function to check and add default values
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!editingHome) {
    setError("No home selected for editing.");
    return;
  }

  const data = new FormData();
  data.append("_method", "PUT");

  // Append other form fields
  data.append("headline", formData.headline || "");
  data.append("desc", formData.desc || "");
  data.append("topBar", formData.topBar || "");
  data.append("slug", formData.slug || "");
  data.append("subHeadline", formData.subHeadline || "");
  data.append("paragraph", formData.paragraph || "");
  
  // শুধুমাত্র ইমেজ থাকলে append করবে
  if (formData.image instanceof File) {
    data.append("image", formData.image);
  } else if (formData.image) {
    // যদি ইমেজ একটি স্ট্রিং (পূর্বের ইমেজ পাথ) হয়
    data.append("existingImage", formData.image);
  }
  
  data.append("timeText", formData.timeText || "");
  data.append("startsText", formData.startsText || "");
  data.append("startsIn", formData.startsIn || "");
  data.append("seatGrabText", formData.seatGrabText || "");
  data.append("buttonHeadlineText", formData.buttonHeadlineText || "");
  data.append("buttonSubheadlineText", formData.buttonSubheadlineText || "");
  data.append("secretsHeadline", formData.secretsHeadline || "");
  data.append("secretsText", formData.secretsText || "");
  data.append("footerText", formData.footerText || "");
  data.append("pixelId", formData.pixelId || "");

  try {
    setLoading(true);
    setError(null);
    
    const response = await axios.post(
      `${apiUrl}/homepagesupdate/${editingHome}`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    alert("Home updated successfully");
    setHomes((prev) =>
      prev.map((home) =>
        home.id === editingHome ? { ...home, ...formData, image: response.data.image || home.image } : home
      )
    );
    setEditingHome(null); // Clear editing state
  } catch (err) {
    console.error("Error updating home:", err?.response?.data?.message);
    setError(err?.response?.data?.message || "Failed to update home.");
  } finally {
    setLoading(false);
  }
};


  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-center">Homepage List</h2>
      {error && <p className="text-red-500">{error}</p>}
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            <th className="border border-gray-300 px-4 py-2">Slug</th>
            <th className="border border-gray-300 px-4 py-2">Image</th>
            <th className="border border-gray-300 px-4 py-2">Headline</th>
            <th className="border border-gray-300 px-4 py-2">Sub Headline</th>
            <th className="border border-gray-300 px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {homes.map((home) => (
            <tr key={home.id}>
              <td className="border border-gray-300 px-4 py-2">{home.slug}</td>
              <td className="border border-gray-300 px-4 py-2">
                {home.image && (
                  <img
                    src={`${imageUrl}/${home.image}`}
                    alt="Image"
                    className="h-12 w-12 object-cover"
                  />
                )}
              </td>
              <td className="border border-gray-300 px-4 py-2">{home.headline}</td>
              <td className="border border-gray-300 px-4 py-2">
                {home.subHeadline}
              </td>
              <td className="flex flex-col gap-2 border border-gray-300 px-4 py-2">
                <button
                  onClick={() => handleEditClick(home)}
                  className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(home.id)}
                  className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                >
                  Delete
                </button>
                
                <Link to={`/${home.slug}`} className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2">View</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {editingHome && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 max-h-screen overflow-y-auto">
          <div className="p-6 mx-auto bg-white shadow rounded-lg min-w-[800px]">
            <UpdateHome
              formData={formData}
              handleQuillChange={handleQuillChange}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              setPhoto={setPhoto}
              handleImageChange={handleImageChange}
              onCancel={() => setEditingHome(null)}
              loading={loading}
              error={error}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewHome;
